window.calculateDisplayStart = function() {
    var params = new URL(window.location).searchParams
    var start = 0
    var pageLength = params.get('page_len') ? params.get('page_len') : 10

    if (params.get('page')) {
        start  = params.get('page') * pageLength
    }

    return start
}
    
window.getColumnSearch = function(value){
    return { 
        'search': value ? '^' + value + '$' : '', 
        'regex': true, 
        'smart': false 
    }
}

/**
 * No longer sets the values for the drop downs
 * but does still setup the required listener.
 */
window.createColumnSelectFilter = function(){
    var column = this;
    var columnHeader = $(column.header());
    var nthColumn = columnHeader.index() + 1

    columnHeader
        .parent('tr')
        .prev()
        .find('td:nth-child(' + nthColumn + ') select')
        .on('change', function () {
            var val = $.fn.dataTable.util.escapeRegex($(this).val());

            column
                .search( val ? '^'+val+'$' : '', true, false )
                .draw();
        });
}

window.toggleExpandButton = function(button, showCloseFace){
    var icon = button.children('span');

    showCloseFace = (typeof showCloseFace !== 'undefined') ?  showCloseFace : true;

    if(showCloseFace){
        button.removeClass('btn-success');
        button.addClass('btn-danger');
        icon.removeClass('glyphicon-plus');
        icon.addClass('glyphicon-minus');
    } else {
        button.removeClass('btn-danger');
        button.addClass('btn-success');
        icon.removeClass('glyphicon-minus');
        icon.addClass('glyphicon-plus');
    }
}

/**
 * @todo refactor name to toggleRow
 */
window.showDetailsRow = function(tr, table, template, show){
    var row = table.row(tr);
    var button = tr.find('.btn-expand-row');

    if (typeof show !== 'undefined') {
        if (show) {
            return showRow(row, button, template);
        }

        return hideRow(row, button);
    }

    if (row.child.isShown()) {
        return hideRow(row, button);
    }

    showRow(row, button, template);
}

window.showRow = function(row, button, template){
    var html = template(row.data());

    row.child(html).show();

    toggleExpandButton(button, true);
}

window.hideRow = function(row, button){
    row.child.hide();

    toggleExpandButton(button, false);
}

window.isExpandButtonsAllClosed = function(){
    return $('.btn-expand-row').hasClass('btn-danger');
}

window.franchiseRoute = function(url) {
    var franchiseSlug = $('nav').data('franchiseSlug')
    
    return '/' + franchiseSlug + '/' + url;
}

$("body").on("click", ".remove-clone-element", function(e) {
    
    e.preventDefault();
    
    var element = $(this);
    element.closest(".clone-element").remove();
    
});

$("body").on("click", ".add-clone-element", function(e) {
    
    e.preventDefault();
    
    var element = $($(this).data("template")).clone().html();
    element = element.replace(/__INDEX__/g, $(".clone-element").length + 1)
    
    $($(this).data("list")).append(element);
    
});

$('body').on('click', '.show-invoice-preview-modal', function(e){
    var invoiceId = $('#invoice-preview').data('invoice-id');
    $.ajax({
        url: franchiseRoute('invoices/'+invoiceId+'/preview'),
        method: 'GET',
        data: {},
        beforeSend: function(){
            $('.invoice-loading').show();
        },
        success: function(response){
            $('#invoice-preview').html(response);
            $('#invoice-preview').show();
            $('.invoice-loading').hide();
            console.log('hello');
            console.log(response);
        }
    });
});